{
  "Accessibility Menu": "منوی دسترسی",
  "Reset settings": "بازنشانی تنظیمات",
  "Close": "بستن",
  "Content Adjustments": "تنظیمات محتوا",
  "Adjust Font Size": "تنظیم اندازه فونت",
  "Highlight Title": "برجسته کردن عنوان",
  "Highlight Links": "برجسته کردن لینک‌ها",
  "Readable Font": "فونت خوانا",
  "Color Adjustments": "تنظیمات رنگ",
  "Dark Contrast": "کنتراست تاریک",
  "Light Contrast": "کنتراست روشن",
  "High Contrast": "کنتراست بالا",
  "High Saturation": "اشباع بالا",
  "Low Saturation": "اشباع پایین",
  "Monochrome": "تک‌رنگ",
  "Contrast": "کنتراست",
  "Invert Colors": "وارونه کردن رنگ‌ها",
  "Tools": "ابزارها",
  "Reading Guide": "راهنمای خواندن",
  "Stop Animations": "توقف انیمیشن‌ها",
  "Big Cursor": "مؤشر بزرگ",
  "Increase Font Size": "افزایش اندازه فونت",
  "Decrease Font Size": "کاهش اندازه فونت",
  "Letter Spacing": "فاصله بین حروف",
  "Line Height": "ارتفاع خط",
  "Font Weight": "وزن فونت",
  "Dyslexia Font": "فونت دیسلکسیا",
  "Language": "زبان",
  "Open Accessibility Menu": "بازکردن منوی دسترسی",
  "Widget Settings": "تنظیمات ویجت",
  "Widget Position": "موقعیت ویجت",
  "Top Left": "بالا چپ",
  "Top Center": "بالا مرکز",
  "Top Right": "بالا راست",
  "Center Left": "مرکز چپ",
  "Center Right": "مرکز راست",
  "Bottom Left": "پایین چپ",
  "Bottom Center": "پایین مرکز",
  "Bottom Right": "پایین راست",
  "Screen Reader": "صفحه‌خوان",
  "Voice Navigation": "پیمایش صوتی",
  "Custom Color": "رنگ سفارشی",
  "Change the site's colors": "رنگ‌های سایت را تغییر دهید",
  "Backgrounds": "پس‌زمینه‌ها",
  "Headings": "سرفصل‌ها",
  "Contents": "محتوا",
  "Reset colors": "بازنشانی رنگ‌ها",
  "Image Desaturation": "کاهش اشباع تصویر",
  "Search languages": "جستجوی زبان‌ها",
  "No languages found": "زبانی یافت نشد",
  "Accessibility Profiles": "نمایه‌های دسترس‌پذیری",
  "Motor Impaired": "ناتوانی حرکتی",
  "Big cursor, voice navigation, and no animations.": "نشانگر بزرگ، ناوبری صوتی و بدون انیمیشن.",
  "Blind": "نابینا",
  "Screen reader helpers with higher contrast.": "کمک‌های صفحه‌خوان با کنتراست بیشتر.",
  "Color Blind": "کوررنگی",
  "High contrast palette with desaturated media.": "پالت با کنتراست بالا و رسانه‌های کم‌رنگ.",
  "Dyslexia": "دیسلکسی",
  "Friendly font, extra spacing, stronger weight.": "فونت خوانا، فاصله بیشتر و ضخامت قوی‌تر.",
  "Low vision": "کم‌بینا",
  "Dark contrast and 130% magnification.": "کنتراست تیره و بزرگ‌نمایی ۱۳۰٪.",
  "Cognitive & Learning": "شناختی و یادگیری",
  "Highlights key sections and enables voice help.": "بخش‌های کلیدی را برجسته می‌کند و کمک صوتی فعال می‌شود.",
  "Seizure & Epileptic": "تشنج و صرع",
  "Stops animations and desaturates imagery.": "انیمیشن‌ها را متوقف و تصاویر را کم‌رنگ می‌کند.",
  "ADHD": "بیش‌فعالی",
  "Reading guide, highlighted links, calmer palette.": "راهنمای مطالعه، لینک‌های هایلایت‌شده و پالت آرام‌تر.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
